export default "__VITE_ASSET__DZQgIzAG__"